import { IFileImportServiceMock } from "@/services/backend/file_import/file_import.types";

export const mockFileImportService = (): IFileImportServiceMock => ({
  getTemplateFileImportServicepoint: jest.fn(),
  addMassiveFileImportServicepoint: jest.fn(),
  getImports: jest.fn(),
  deleteImport: jest.fn(),
  downloadImport: jest.fn(),
});
